// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".houseingRes[data-v-0d58e201] .avue-crud__menu{display:none}.cell-color[data-v-0d58e201]{color:#409eff!important;cursor:pointer}[data-v-0d58e201] .el-table th.is-leaf{padding-left:15px;padding-right:15px}[data-v-0d58e201] .avue-crud__menu{display:none}", ""]);
// Exports
module.exports = exports;
